<template>
  <v-container fluid>
    <v-row>
      <v-col cols="12" sm="12">
        <v-layout>
          <v-dialog
              ref="dialog"
              v-model="modal"
              :return-value.sync="date"
              persistent
              width="290px"
          >
            <template v-slot:activator="{ on, attrs }">
              <v-text-field
                  :value="computedDate"
                  label="Choose Date to query from"
                  prepend-icon="mdi-calendar"
                  readonly
                  v-bind="attrs"
                  v-on="on"
                  @click:clear="date = null"
                  clearable
              ></v-text-field>
            </template>
            <v-date-picker v-model="date" scrollable>
              <v-spacer></v-spacer>
              <v-btn text color="primary" @click="modal = false">Cancel</v-btn>
              <v-btn text color="primary" @click="$refs.dialog.save(date)">OK</v-btn>
            </v-date-picker>
          </v-dialog>

          <v-autocomplete v-model="periodDate" label="Select Period" class="ml-3" :items="periods" item-value="startDate" item-text="name" />
        </v-layout>
      </v-col>
      <v-col cols="12" sm="12">
          <v-card>
            <v-card-title>Commission Summary Per Technician</v-card-title>
            <v-card-text>
              <h5>Weekly Turnover: {{accounting.formatMoney(weeklyTurnover, '£', 2)}}</h5>
              <h5 class="mt-2">Weekly Commission Per Technician:</h5>
              <h6 class="mt-2" v-for="(t, index) in parsedTechnicians" :key="index">
                {{getWeeklyTotalForTech(t.text)}}
              </h6>
            </v-card-text>
          </v-card>
      </v-col>
      <v-col cols="12" sm="12">
        <v-row>
          <v-col>
            <v-data-iterator
                :items="day1"
                hide-default-footer
            >
              <template v-slot:header>
                <v-toolbar
                    class="mb-2"
                    color="black"
                    dark
                    flat
                >
                  <v-toolbar-title>{{ date | moment('DD/MM/YYYY') }} - {{accounting.formatMoney(day1Total, '£', 2)}}</v-toolbar-title>
                </v-toolbar>
              </template>
              <template v-slot:default="props">
                <v-row>
                  <v-col
                      v-for="(item, index) in props.items"
                      :key="index"
                      cols="12"
                      sm="12"
                  >
                    <v-card>
                      <v-card-title>{{ item._id.valet }}</v-card-title>
                      <v-card-text>
                        <p>17.5% Commission: {{ accounting.formatMoney(item.total17, '£', 2) }}</p>
                        <p>30% Commission: {{ accounting.formatMoney(item.total30, '£', 2) }}</p>
                        <p>40% Commission: {{ accounting.formatMoney(item.total40, '£', 2) }}</p>
                        <p>60% Commission: {{ accounting.formatMoney(item.total60, '£', 2) }}</p>
                        <p>100% Commission: {{ accounting.formatMoney(item.total100, '£', 2) }}</p>
                        <p class="subtitle-1">Total Commission:
                          {{ accounting.formatMoney(item.totalCommission, '£', 2) }}</p>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </template>
            </v-data-iterator>
          </v-col>

          <v-col>
            <v-data-iterator
                :items="day2"
                hide-default-footer
            >
              <template v-slot:header>
                <v-toolbar
                    class="mb-2"
                    color="black"
                    dark
                    flat
                >
                  <v-toolbar-title>{{ $moment(date).add(1, 'days') | moment('DD/MM/YYYY') }} - {{accounting.formatMoney(day2Total, '£', 2)}}</v-toolbar-title>
                </v-toolbar>
              </template>
              <template v-slot:default="props">
                <v-row>
                  <v-col
                      v-for="(item, index) in props.items"
                      :key="index"
                      cols="12"
                      sm="12"
                  >
                    <v-card>
                      <v-card-title>{{ item._id.valet }}</v-card-title>
                      <v-card-text>
                        <p>17.5% Commission: {{ accounting.formatMoney(item.total17, '£', 2) }}</p>
                        <p>30% Commission: {{ accounting.formatMoney(item.total30, '£', 2) }}</p>
                        <p>40% Commission: {{ accounting.formatMoney(item.total40, '£', 2) }}</p>
                        <p>60% Commission: {{ accounting.formatMoney(item.total60, '£', 2) }}</p>
                        <p>100% Commission: {{ accounting.formatMoney(item.total100, '£', 2) }}</p>
                        <p class="subtitle-1">Total Commission:
                          {{ accounting.formatMoney(item.totalCommission, '£', 2) }}</p>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </template>
            </v-data-iterator>
          </v-col>

          <v-col>
            <v-data-iterator
                :items="day3"
                hide-default-footer
            >
              <template v-slot:header>
                <v-toolbar
                    class="mb-2"
                    color="black"
                    dark
                    flat
                >
                  <v-toolbar-title>{{ $moment(date).add(2, 'days') | moment('DD/MM/YYYY') }} - {{accounting.formatMoney(day3Total, '£', 2)}}</v-toolbar-title>
                </v-toolbar>
              </template>
              <template v-slot:default="props">
                <v-row>
                  <v-col
                      v-for="(item, index) in props.items"
                      :key="index"
                      cols="12"
                      sm="12"
                  >
                    <v-card>
                      <v-card-title>{{ item._id.valet }}</v-card-title>
                      <v-card-text>
                        <p>17.5% Commission: {{ accounting.formatMoney(item.total17, '£', 2) }}</p>
                        <p>30% Commission: {{ accounting.formatMoney(item.total30, '£', 2) }}</p>
                        <p>40% Commission: {{ accounting.formatMoney(item.total40, '£', 2) }}</p>
                        <p>60% Commission: {{ accounting.formatMoney(item.total60, '£', 2) }}</p>
                        <p>100% Commission: {{ accounting.formatMoney(item.total100, '£', 2) }}</p>
                        <p class="subtitle-1">Total Commission:
                          {{ accounting.formatMoney(item.totalCommission, '£', 2) }}</p>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </template>
            </v-data-iterator>
          </v-col>

          <v-col>
            <v-data-iterator
                :items="day4"
                hide-default-footer
            >
              <template v-slot:header>
                <v-toolbar
                    class="mb-2"
                    color="black"
                    dark
                    flat
                >
                  <v-toolbar-title>{{ $moment(date).add(3, 'days') | moment('DD/MM/YYYY') }} - {{accounting.formatMoney(day4Total, '£', 2)}}</v-toolbar-title>
                </v-toolbar>
              </template>
              <template v-slot:default="props">
                <v-row>
                  <v-col
                      v-for="(item, index) in props.items"
                      :key="index"
                      cols="12"
                      sm="12"
                  >
                    <v-card>
                      <v-card-title>{{ item._id.valet }}</v-card-title>
                      <v-card-text>
                        <p>17.5% Commission: {{ accounting.formatMoney(item.total17, '£', 2) }}</p>
                        <p>30% Commission: {{ accounting.formatMoney(item.total30, '£', 2) }}</p>
                        <p>40% Commission: {{ accounting.formatMoney(item.total40, '£', 2) }}</p>
                        <p>60% Commission: {{ accounting.formatMoney(item.total60, '£', 2) }}</p>
                        <p>100% Commission: {{ accounting.formatMoney(item.total100, '£', 2) }}</p>
                        <p class="subtitle-1">Total Commission:
                          {{ accounting.formatMoney(item.totalCommission, '£', 2) }}</p>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </template>
            </v-data-iterator>
          </v-col>

          <v-col>
            <v-data-iterator
                :items="day5"
                hide-default-footer
            >
              <template v-slot:header>
                <v-toolbar
                    class="mb-2"
                    color="black"
                    dark
                    flat
                >
                  <v-toolbar-title>{{ $moment(date).add(4, 'days') | moment('DD/MM/YYYY') }} - {{accounting.formatMoney(day5Total, '£', 2)}}</v-toolbar-title>
                </v-toolbar>
              </template>
              <template v-slot:default="props">
                <v-row>
                  <v-col
                      v-for="(item, index) in props.items"
                      :key="index"
                      cols="12"
                      sm="12"
                  >
                    <v-card>
                      <v-card-title>{{ item._id.valet }}</v-card-title>
                      <v-card-text>
                        <p>17.5% Commission: {{ accounting.formatMoney(item.total17, '£', 2) }}</p>
                        <p>30% Commission: {{ accounting.formatMoney(item.total30, '£', 2) }}</p>
                        <p>40% Commission: {{ accounting.formatMoney(item.total40, '£', 2) }}</p>
                        <p>60% Commission: {{ accounting.formatMoney(item.total60, '£', 2) }}</p>
                        <p>100% Commission: {{ accounting.formatMoney(item.total100, '£', 2) }}</p>
                        <p class="subtitle-1">Total Commission:
                          {{ accounting.formatMoney(item.totalCommission, '£', 2) }}</p>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </template>
            </v-data-iterator>
          </v-col>

          <v-col>
            <v-data-iterator
                :items="day6"
                hide-default-footer
            >
              <template v-slot:header>
                <v-toolbar
                    class="mb-2"
                    color="black"
                    dark
                    flat
                >
                  <v-toolbar-title>{{ $moment(date).add(5, 'days') | moment('DD/MM/YYYY') }} - {{accounting.formatMoney(day6Total, '£', 2)}}</v-toolbar-title>
                </v-toolbar>
              </template>
              <template v-slot:default="props">
                <v-row>
                  <v-col
                      v-for="(item, index) in props.items"
                      :key="index"
                      cols="12"
                      sm="12"
                  >
                    <v-card>
                      <v-card-title>{{ item._id.valet }}</v-card-title>
                      <v-card-text>
                        <p>17.5% Commission: {{ accounting.formatMoney(item.total17, '£', 2) }}</p>
                        <p>30% Commission: {{ accounting.formatMoney(item.total30, '£', 2) }}</p>
                        <p>40% Commission: {{ accounting.formatMoney(item.total40, '£', 2) }}</p>
                        <p>60% Commission: {{ accounting.formatMoney(item.total60, '£', 2) }}</p>
                        <p>100% Commission: {{ accounting.formatMoney(item.total100, '£', 2) }}</p>
                        <p class="subtitle-1">Total Commission:
                          {{ accounting.formatMoney(item.totalCommission, '£', 2) }}</p>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </template>
            </v-data-iterator>
          </v-col>

          <v-col>
            <v-data-iterator
                :items="day7"
                hide-default-footer
            >
              <template v-slot:header>
                <v-toolbar
                    class="mb-2"
                    color="black"
                    dark
                    flat
                >
                  <v-toolbar-title>{{ $moment(date).add(6, 'days') | moment('DD/MM/YYYY') }} - {{accounting.formatMoney(day7Total, '£', 2)}}</v-toolbar-title>
                </v-toolbar>
              </template>
              <template v-slot:default="props">
                <v-row>
                  <v-col
                      v-for="(item, index) in props.items"
                      :key="index"
                      cols="12"
                      sm="12"
                  >
                    <v-card>
                      <v-card-title>{{ item._id.valet }}</v-card-title>
                      <v-card-text>
                        <p>17.5% Commission: {{ accounting.formatMoney(item.total17, '£', 2) }}</p>
                        <p>30% Commission: {{ accounting.formatMoney(item.total30, '£', 2) }}</p>
                        <p>40% Commission: {{ accounting.formatMoney(item.total40, '£', 2) }}</p>
                        <p>60% Commission: {{ accounting.formatMoney(item.total60, '£', 2) }}</p>
                        <p>100% Commission: {{ accounting.formatMoney(item.total100, '£', 2) }}</p>
                        <p class="subtitle-1">Total Commission:
                          {{ accounting.formatMoney(item.totalCommission, '£', 2) }}</p>
                      </v-card-text>
                    </v-card>
                  </v-col>
                </v-row>
              </template>
            </v-data-iterator>
          </v-col>
        </v-row>
      </v-col>
    </v-row>

  </v-container>
</template>

<script>
import {ReportsHttp} from "@/http/ReportsHttp";
import {mapState} from "vuex";
import accounting from 'accounting';
import {PeriodsHttp} from "@/http/PeriodsHttp";

export default {
  name: "WeekSheet",
  computed: {
    ...mapState("technicians", ["appTechnicians"]),
    computedDate () {
      return this.date ? this.$moment(this.date).format('DD/MM/YYYY') : ''
    },
  },
  methods: {
      getWeeklyTotalForTech(tech) {
        let total = 0;
        if (this.res) {
          const summaries = this.res.filter(x => x._id.valet === tech);
          // eslint-disable-next-line no-console
          console.log(summaries);
          summaries.forEach(s => {
              total = total + s.totalCommission;
          });
        }

        return `${tech} - ${this.accounting.formatMoney(total, '£', 2)}`;
      }
  },
  async mounted() {
      this.periods = await PeriodsHttp.getPeriods().then(result => result.data);
      this.periodDate = await PeriodsHttp.getPeriodByDate(this.$moment().format('YYYY-MM-DD')).then(result => result.data.startDate);
      this.date = this.$moment(this.periodDate).format('YYYY-MM-DD');
  },
  data() {
    return {
      date: new Date().toISOString().substr(0, 10),
      modal: false,
      res: null,
      parsedTechnicians: [],
      day1: [],
      day2: [],
      day3: [],
      day4: [],
      day5: [],
      day6: [],
      day7: [],
      day1Total: 0,
      day2Total: 0,
      day3Total: 0,
      day4Total: 0,
      day5Total: 0,
      day6Total: 0,
      day7Total: 0,
      weeklyTurnover: 0,
      accounting: accounting,
      periods: [],
      periodDate: ''
    }
  },
  watch: {
    periodDate(newVal) {
      this.date = this.$moment(newVal).format('YYYY-MM-DD');
    },
    async date(newVal) {
      this.weeklyTurnover = 0;
      this.res = await ReportsHttp.getWeekSheets(newVal).then(result => result.data);
      this.day1Total = 0;
      this.day2Total = 0;
      this.day3Total = 0;
      this.day4Total = 0;
      this.day5Total = 0;
      this.day6Total = 0;
      this.day7Total = 0;
      this.day1 = [];
      this.day2 = [];
      this.day3 = [];
      this.day4 = [];
      this.day5 = [];
      this.day6 = [];
      this.day7 = [];
      this.res.forEach(d => {
        if (d._id.startDate === newVal) {
          this.day1.push(d);
          this.day1Total = this.day1Total + Number(d.totalLessDeductions);
        }

        if (d._id.startDate === this.$moment(newVal).add(1, 'days').format('YYYY-MM-DD')) {
          this.day2.push(d);

          this.day2Total = this.day2Total + Number(d.totalLessDeductions);
        }

        if (d._id.startDate === this.$moment(newVal).add(2, 'days').format('YYYY-MM-DD')) {
          this.day3.push(d);

          this.day3Total = this.day3Total + Number(d.totalLessDeductions);
        }

        if (d._id.startDate === this.$moment(newVal).add(3, 'days').format('YYYY-MM-DD')) {
          this.day4.push(d);

          this.day4Total = this.day4Total + Number(d.totalLessDeductions);
        }

        if (d._id.startDate === this.$moment(newVal).add(4, 'days').format('YYYY-MM-DD')) {
          this.day5.push(d);

          this.day5Total = this.day5Total + Number(d.totalLessDeductions);
        }

        if (d._id.startDate === this.$moment(newVal).add(5, 'days').format('YYYY-MM-DD')) {
          this.day6.push(d);

          this.day6Total = this.day6Total + Number(d.totalLessDeductions);
        }

        if (d._id.startDate === this.$moment(newVal).add(6, 'days').format('YYYY-MM-DD')) {
          this.day7.push(d);
          this.day7Total = this.day7Total + Number(d.totalLessDeductions);
        }

        this.weeklyTurnover = this.day1Total + this.day2Total + this.day3Total + this.day4Total + this.day5Total + this.day6Total + this.day7Total;

      });
    },
    appTechnicians: {
      handler(newVal) {
        this.parsedTechnicians = [];
        newVal.forEach(v => {
          if (v.name !== 'Office' && v.name !== 'Daniel' && v.name !== 'COST' && v.name !== 'Hamza' && v.name !== 'Reschedule' && v.name !== 'Cancellation') {
            this.parsedTechnicians.push({
              text: v.name,
              id: v._id,
              region: v.region
            });
          }

        });
      },
      deep: true,
      immediate: true
    }
  }
}
</script>
